module.exports = __webpack_public_path__ + "static/media/cs50_ide.3072a27f.png";